<div class="table-view">
    <!-- Table starts -->
    <p-table #dt [value]="consumptiondata" [rows]="10" [paginator]="true" [pageLinks]="3"
        [rowsPerPageOptions]="[5,10,20]">
        <!-- Header -->
        <ng-template pTemplate="header">
            <tr>
                <th>Title</th>
                <th>LanguageId</th>
                <th>Description</th>
                <th>BaseUrl</th>
                <th>DocsPath</th>
                <th>LogoPath</th>
                <th>DomainUrl</th>
                <th>DocsPath</th>
                <th>LogoPath</th>
                <th></th>
            </tr>
        </ng-template>
        <!-- Body Content -->
        <ng-template pTemplate="body" let-appList>
            <tr>
                <td>
                    <span>{{appList.Title}}</span>
                </td>
                <td>
                    <span>{{appList.LanguageId}}</span>
                </td>
                <td>
                    <span>{{appList.Description}}</span>
                </td>
                <td>
                    <span>{{appList.BaseUrl}}</span>
                </td>
                <td>
                    <span>{{appList.DocsPath}}</span>
                </td>
                <td>
                    <span>{{appList.LogoPath}}</span>
                </td>
                <td>
                    <span>{{appList.DomainUrl}}</span>
                </td>
                <td>
                    <span>{{appList.Theme}}</span>
                </td>
                <td>
                    <span>{{appList.Language}}</span>
                </td>
                <td class="col-button">
                    <a routerLink="new" [routerLink]="['./../new',appList.Id]" 
                        routerLinkActive="active" title="{{'EDIT' | translate}}" [attr.aria-label]="'EDIT' | translate" class="kuba-icon-btn kuba-icon-btn--ghost kuba-icon-btn--row"><i class="pi pi-pencil"></i></a>
                    <button type="button"  (click)="confirm()"
                        title="{{'DELETE' | translate}}"
            [attr.aria-label]="'DELETE' | translate" class="kuba-icon-btn kuba-icon-btn--danger kuba-icon-btn--row">
            <i class="pi pi-trash"></i>
          </button>
                </td>
            </tr>
        </ng-template>
    </p-table>
    <!-- Table ends -->
</div>